export default __webpack_public_path__ + "static/media/wellstar.22a276b2.svg";